// @flow
import client from '../../client'

// Endpoints
export const GET_AIRLINES_ENDPOINT = '/flights/airlines/'

// Types
export type Airline = {
  value: string,
  display: string,
}

// Internals
let CACHED_AIRLINES = null

/**
 * Get active airlines
 * @return {Promise|Error} A resolved Promise with an Array of Airlines Objects or Rejected with an Error
 */
export const getAirlines = (): Promise<Airline[]> => {
  if (CACHED_AIRLINES) {
    return Promise.resolve(CACHED_AIRLINES)
  }
  return client.get(GET_AIRLINES_ENDPOINT).then((response): Array<Airline> => {
    CACHED_AIRLINES = response.airlines.map((airline): Airline => ({
      value: airline.airline_code,
      display: airline.airline_name,
    }))
    return CACHED_AIRLINES
  })
}

export default getAirlines
